module.exports = __webpack_public_path__ + "img/222A1287.9bc8c997.png";